import { Link } from 'react-router-dom';

/**
 * Tarjeta de métrica del panel e-CF. Si recibe `to`, toda la tarjeta es un enlace (así se salta
 * del panel a la lista ya filtrada, que es el recorrido natural cuando algo requiere atención).
 */

type Tone = 'neutral' | 'good' | 'warn' | 'bad';

const TONE_TEXT: Record<Tone, string> = {
  neutral: 'text-gray-900',
  good: 'text-green-600',
  warn: 'text-amber-600',
  bad: 'text-red-600',
};

interface StatCardProps {
  icon: string;
  label: string;
  value: number | string;
  hint?: string;
  tone?: Tone;
  to?: string;
}

export default function StatCard({
  icon,
  label,
  value,
  hint,
  tone = 'neutral',
  to,
}: StatCardProps) {
  const toneClass = TONE_TEXT[tone];

  const body = (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 h-full ${
        to ? 'transition-colors hover:bg-gray-50' : ''
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm text-gray-600">{label}</p>
          <p className={`text-2xl font-bold mt-1 ${toneClass}`}>{value}</p>
          {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
        </div>
        <i className={`${icon} text-xl shrink-0 ${toneClass}`}></i>
      </div>
    </div>
  );

  return to ? (
    <Link to={to} className="block h-full">
      {body}
    </Link>
  ) : (
    body
  );
}
